import { B2C_URLS } from '../../templates/components/customers/constants';
import { appendReturnUrl } from '../../templates/components/customers/helpers/helpers';
import { LoginB2cParams, LoginOptions, defaultLoginOptions } from './constants';

const fixReturnUrl = (returnUrl: string): string => {
  if (/\/account\/login/gi.test(returnUrl)) {
    return returnUrl;
  }
  return `/account/login?returnUrl=${encodeURIComponent(returnUrl)}`;
};

const handleLoginOptions = (requestParams: LoginB2cParams, loginOptions: LoginOptions): LoginB2cParams => {
  const extraParams: Record<string, string> = {};
  if (loginOptions.fromReceiptsMicrosite) {
    extraParams.tracking = 'ereceipts';
  }
  return { ...(requestParams ?? {}), ...extraParams };
};

export const handleLoginCreate = (
  returnUrl?: string,
  params: LoginB2cParams = {},
  opts: LoginOptions = defaultLoginOptions
): void => {
  returnUrl = returnUrl ? fixReturnUrl(returnUrl) : '/account/login';
  window.location.href = appendReturnUrl({
    baseUrl: B2C_URLS.loginCreate,
    baseParams: handleLoginOptions(params, opts),
    returnUrl,
  });
};

export const handleLogout = async (returnUrl?: string): Promise<void> => {
  await handleShopifyLogout();
  returnUrl =
    returnUrl ??
    (/\/account[#\/?]?/g.test(window.location.href) ? '' : window.location.href.replace(window.location.origin, ''));

  window.location.href = appendReturnUrl({ baseUrl: B2C_URLS.logout, returnUrl });
};

export const handleShopifyLogout = async () => {
  await fetch('/account/logout').catch(err => console.error(err));
};
